module.exports = __webpack_public_path__ + "817c6d5306ad44177d6e945f94a87455.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/jingjing.png
// module id = 606
// module chunks = 30